<template>
	<div>
		<v-row v-if="!online" no-gutters>
			<v-col cols="12" md="6" class="pa-2">
				<v-select
					v-model="value.country"
					outlined
					hide-details="auto"
					label="الدولة"
					:items="countries"
					item-text="name"
					item-value="countryID"
					:rules="[rules.required]"
				></v-select>
			</v-col>
			<v-col cols="12" md="6" class="pa-2">
				<v-select
					v-model="value.region"
					outlined
					hide-details="auto"
					label="المنطقة"
					:items="regions"
					item-text="name"
					item-value="regionID"
					:rules="[rules.required]"
				></v-select>
			</v-col>
			<v-col cols="12" md="6" class="pa-2">
				<v-select
					v-model="value.city"
					outlined
					hide-details="auto"
					label="المدينة"
					:items="cities"
					item-text="name"
					item-value="cityID"
					:rules="[rules.required]"
				></v-select>
			</v-col>
			<v-col cols="12" md="6" class="pa-2">
				<v-select
					v-model="value.place"
					outlined
					hide-details="auto"
					label="المكان"
					:items="places"
					item-text="name"
					item-value="id"
					:rules="[rules.required]"
				>
					<template v-if="value.city" #prepend-item>
						<v-list-item @click="showAddNewPlace = true">
							<v-list-item-title>إضافة مكان جديد</v-list-item-title>
							<v-list-item-action>
								<v-icon>mdi-plus</v-icon>
							</v-list-item-action>
						</v-list-item>
					</template>
				</v-select>
			</v-col>
		</v-row>

		<v-dialog v-model="showAddNewPlace" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة مكان جديد</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid1">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-select
									v-model="value.city"
									outlined
									label="المدينة"
									:items="cities"
									item-text="name"
									item-value="cityID"
									disabled
								></v-select>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newName"
									outlined
									label="اسم المكان"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-switch
									v-model="isHospital"
									label="مستشفى"
									hide-details
									class="my-0 py-0"
								></v-switch>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn
									color="primary"
									:disabled="!valid1"
									:loading="loading"
									@click="addNewPlace"
									>
									إضافة
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin],
	props: {
		value: {
			type: Object,
			required: true,
		},
		online: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			loading: false,
			valid1: false,
            
			countries: [],
			regions: [],
			cities: [],
			places: [],

			showAddNewPlace: false,
			newName: null,
			isHospital: false,
			locationLink: null,
		};
	},
	watch: {
		valid(newVal){
			console.log(newVal)
		},
		"value.country"(newVal) {
			this.value.region = null;
			this.regions = [];
			this.getRegions(newVal);
		},
		"value.region"(newVal) {
			this.value.city = null;
			this.cities = [];
			this.getCities(newVal);
		},
		"value.city"(newVal) {
			this.value.place = null;
			this.places = [];
			this.getPlaces(newVal);
		},
	},
	mounted() {
		this.getCountries();
	},
	methods: {
		getCountries() {
			client
				.get("/api/location/countries")
				.then((response) => {
					this.countries = response.data.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getRegions(countryID) {
			client
				.post("/api/location/countryregions", { countryID: countryID })
				.then((response) => {
					this.regions = response.data.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getCities(regionID) {
			client
				.post("/api/location/regioncities", { regionID: regionID })
				.then((response) => {
					this.cities = response.data.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getPlaces(cityID) {
			client
				.get("/api/location/cityplaces/" + cityID)
				.then((response) => {
					this.places = response.data.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		addNewPlace() {
			this.loading = true;
			var data = {
				cityID: this.value.city,
				name: this.newName,
				isHospital: this.isHospital,
				locationLink: this.locationLink
			}

			clientNotifier
				.post("/api/location/addPlace", data)
				.then(response => {
					this.loading = false;
					this.showAddNewPlace = false
					this.places.push({
						id: response.data.data.id,
						name: response.data.data.name,
					})

					this.value.place = response.data.data.id;
				})
				.catch(err => {
					console.log(err);
					this.loading = false;
				});
		},
	},
};
</script>
